/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
import ccTab from '@/components/common/tab/index.vue';
import contentTable from '@/components/common/more-tab-content/content-table/index.vue';

export default {
    name: 'hsal',
    components: {ccTab, contentTable},
    data() {
        return {
            tabList: [
                {
                    name: '指导性案例',
                    code: 'zdxal'
                },
                {
                    name: '公报案例',
                    code: 'gbal'
                },
                {
                    name: '全国海事典型案例',
                    code: 'ndaljx'
                },
                {
                    name: '人民法院案例库',
                    code: 'rmfyalk'
                },
                {
                    name: '地方法院精选案例',
                    code: 'dffyjxal'
                },
                {
                    name: '调研文章',
                    code: 'dywz'
                }
            ],
            activeTab: 'zdxal',
            fbdwList: [],
            total: 0,
            almk: '0',
            ejlb: '',
            data: {
                limit: 10,
                offset: 0,
                total: 0
            },
            // 查询条件
            searchData:{
                fbsj:[],
                title: '',
                nf: '',
                fbdw:''
            },
            nfList:[]
        };
    },
    computed: {
        crumbsList() {
            const list = [{
                name:'审判研究',
                key:'hsal',
                path:'/hsal'
            }];
            const listItem = this.tabList.filter(item => item.code === this.activeTab)[0];
            listItem.key = listItem.code;
            list.push(listItem);
            return Object.freeze(list);
        }
    },
    mounted() {
        this.init();
        this.dealYear();
        this.getFbdwList();
    },
    methods: {
        // 点击查询
        clickSearch() {
            this.searchData.title.replace(/(^\s*)|(\s*$)/g, '');
            this.init();
        },
        getFbdwList() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.Hsal.fbdwList
            }).then((res) => {
                if (res.data) {
                    this.fbdwList = res.data;
                }
            });
        },
        // 重置
        resetSearch() {
            // 清空数据
            this.searchData.fbsj = [];
            this.searchData.title = '';
            this.searchData.nf = '';
            this.searchData.fbdw = '';
            // 请求
            this.clickSearch();
        },
        init() {
            this.activeTab = this.$route.query.tab || 'zdxal';
            if (this.activeTab === 'zdxal') {
                this.ejlb = '0';
            } else if (this.activeTab === 'gbal') {
                this.ejlb = '1';
            } else if (this.activeTab === 'dffyjxal') {
                this.ejlb = '18';
            } else if (this.activeTab === 'rmfyalk') {
                this.ejlb = '22';
            } else {
                this.ejlb = '2';
            }
            this.data.limit = 10;
            this.data.offset = 0;
            this.getData({limit:10, offset:0});
        },
        // 截取信息加'...'
        getMsg(msg) {
            const strLength = 145;
            return msg.length > strLength ? `${msg.substring(0, strLength)}...` : msg;
        },
        // 页签切换
        handelTabChange(code) {
            this.activeTab = code;
            if (this.activeTab === 'zdxal') {
                this.ejlb = '0';
                this.searchData.nf = '';
            } else if (this.activeTab === 'gbal') {
                this.ejlb = '1';
                this.searchData.nf = '';
            } else if (this.activeTab === 'dffyjxal') {
                this.ejlb = '18';
                this.searchData.nf = '';
            } else {
                this.ejlb = '2';
            }
            this.data.limit = 10;
            this.data.offset = 0;
            this.resetSearch();
        },
        clickAlxq(item) {
            const _query = {active:'hsal', bh: item.bh, ejlb: item.ejlb};
            if (this.activeTab === 'dywz') {
                _query.active = 'lltt';
            }
            const url = this.$router.resolve({path: '/lltt/dedail', query: _query});
            window.open(url.href, '_blank');
        },
        // 获取列表
        getData(queryInfo) {
            const queryParam = {
                fbsjFrom: '',
                fbsjTo: ''
            };
            if (this.searchData.fbsj.length) {
                queryParam.fbsjFrom = this.searchData.fbsj[0];
                queryParam.fbsjTo = this.searchData.fbsj[1];
            }
            let params = {
                almk: this.almk,
                ejlb: this.ejlb,
                fbsjFrom: queryParam.fbsjFrom ? `${queryParam.fbsjFrom} 00:00:00` : '',
                fbsjTo: queryParam.fbsjTo ? `${queryParam.fbsjTo} 23:59:59` : '',
                title: this.searchData.title,
                nf: this.searchData.nf,
                fbdw:this.searchData.fbdw
            };
            if (queryInfo) {
                params = {
                    ...queryInfo,
                    ...params
                };
            }
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.Hsal.hsalb,
                params:params
            }).then((res) => {
                this.data = res.data;
            });
        },
        dealYear() {
            const list = [];
            const _year = new Date().getFullYear();
            for (let i = 0; i < 10; i++) {
                const result = Number(_year) - i;
                list.push({
                    name:result,
                    code:result.toString()
                });
            }
            this.nfList = list;
        }
    }
};

